<template>
  <div>
    <input
      type="number"
      :name="name"
      class="form-control form-control-sm"
      v-model="post"
      @input="send"
      @change="send"
      :required="required"
    />
  </div>
</template>

<script>
export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content
    };
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post
      });
    }
  }
};
</script>